import { useState } from "react";
import logo from "./logo.svg";
import Core from "./app.module.scss";

function App() {
  const [inputValue, setInputValue] = useState("initial");

  return (
    <div className={`${Core.App}`}>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <input
          style={{ fontSize: 40 }}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button
          type="button"
          onClick={() => {
            throw new Error("runtime error");
          }}
        >
          Throw Runtime errorr
        </button>
        <p>
          Edit <code>src/Ap</code>save to tests
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
